<ng-container *ngIf="designVersion !== 'v3'">
<!-- <app-jobs-candidates-slide-filter [valuesSentForFilters]="entitySent"
  (valuesRetainedForFilters)="onFilterToggle($event)">
  <app-candidate-invited-for-job-filter></app-candidate-invited-for-job-filter>
</app-jobs-candidates-slide-filter> -->
<!-- [class.stickthere-job-applicants]="widgetstick" -->
<!-- Job-level disable: when the job itself is BLOCKED / not active, the
     entire Candidate Invites listing is greyed out and pointer events
     are blocked (no row-level actions allowed). Pairs with the per-row
     disable already inside `app-candidate-card`. -->
<div class="sub-entities-scroll-container"
  [ngClass]="{'disabled': !appliedJob?.availability || appliedJob?.status !== 'ACTIVE'}"
  infiniteScroll [infiniteScrollDistance]="5" [scrollWindow]="false"
  [infiniteScrollThrottle]="200" [alwaysCallback]="true" (scrolled)="onScrollDown()" id="entity-container">
  <div class="hpanel">
    <div class="panel-body pad-10">
      <div class="row">
        <div class="col-sm-8">
          <!-- <div class="filters">
            <div class="filters-list" (click)="removeEntity(item.itemId, i)"
              *ngFor="let item of candidateInvitedStatusList; let i=index;">
              <span class="filter-list-item"><span><i [ngClass]="colorLists[i]"></i></span>
                {{item.value | titlecase}}</span>
              <span class="filter-tag-close-icon-style">
                <svg width="15" height="15" viewBox="0 0 24 24">
                  <path d="M0 0h24v24H0z" fill="none" />
                  <path d="M18 6L6 18M6 6l12 12" stroke="#000" stroke-width="2" stroke-linecap="round"
                    stroke-linejoin="round" />
                </svg>
              </span>
            </div>
          </div> -->
        </div>
        <div class="col-sm-4 all-filters-container">
          <div id="candidates_invited_all_filters_button" class="all-filters-small" (click)="openFilterSlider()">
            <span>
              All Filters
            </span>
            <span *ngIf="candidateInvitedStatusList?.length>0" class="counter">
              {{candidateInvitedStatusList?.length}}
            </span>
            <ng-icon name="tablerFilter"></ng-icon>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="col-md-12 pad-0" *ngIf="loadAPIcall && response?.length==0">
    <app-common-skeleton [countforView]="10" [NameOftheScreen]="'jobcardlarge'"></app-common-skeleton>
  </div>

  <ng-container *ngIf="response?.length > 0; else noResult">
    <div class="col-md-12 pad-0" *ngFor="let item of response;">
      <app-candidate-card [viewSize]="'medium'" [appliedJobDetails]="appliedJob" [filterApplicantData]="filterApplicantData"
        (candidateEmitter)="passCandidateId($event)" [showCheckBox]="false" [inviteapplyhide]="true" [showStatus]="false"
        [datas]="response" [candidateval]="item"
        (jobapp_to_newjob_to_atvity)="pushtoparentcomponent($event)"></app-candidate-card>

      <app-common-skeleton  *ngIf="loadAPIcall && response?.length>0" [countforView]="6" [NameOftheScreen]="'jobcardlarge'"></app-common-skeleton>


    </div>
    <div *ngIf="stopscrollFlag  && response?.length > 0" class="caught_up">
      <div class="col-md-12">
             <ng-icon name="tablerCircleCheck"></ng-icon>
             <!-- <ng-icon name="tablerCircleCheck"></ng-icon> -->
      </div>
      <div class="col-md-12">
        <p class="biase">You've reached the bottom of the page</p>
      </div>
    </div>
  </ng-container>

  <ng-template #noResult>
    <div class="wert">
      <div class="col-md-12 mg-bt-9">
        <ng-icon name="tablerZoomQuestion" *ngIf="responseReceived"></ng-icon>
        <!-- <ng-icon name="customSearchCross" *ngIf="responseReceived"></ng-icon> -->
        <ng-icon name="tablerUserSearch" *ngIf="!responseReceived"></ng-icon>
      </div>
      <div class="col-md-12 fig">{{invitedCandidatesFoundStatus}} </div>
    </div>
  </ng-template>
</div>
</ng-container>

<ng-container *ngIf="designVersion === 'v3'">
  <!-- Re-add "All Filters" trigger on the Candidates Invited V3 tab.
       Mirrors the CG7 fix on candidate-job-invite — same
       `.jc-v3-tab-toolbar` + `.jc-v3-icon-btn.jc-v3-filter-labeled`
       pattern, wired to existing openFilterSlider() with the
       `candidateInvitedStatusList` count badge. -->
  <div class="jc-v3-tab-toolbar jc-v3-tab-toolbar-end">
    <div id="candidates_invited_all_filters_button" class="jc-v3-icon-btn jc-v3-filter-labeled"
         (click)="openFilterSlider()" title="All Filters">
      <span class="jc-v3-filter-label">All Filters</span>
      <span *ngIf="candidateInvitedStatusList?.length > 0" class="filter-count">{{ candidateInvitedStatusList.length }}</span>
      <ng-icon name="tablerFilter"></ng-icon>
    </div>
  </div>

  <!-- Infinite scroll delegated to the outer `.jc-v3-entity-details-body`
       container (see job-applicants / talent-pool pattern). Do NOT add
       `.sub-entities-scroll-container` — that V2-only class globally sets
       `height + overflow-y: scroll` (_common.scss:2305) and makes this
       div its own scroll viewport, stealing wheel events from the outer
       container so `(scrolled)` never fires. -->
  <!-- Job-level disable: blocked / non-active job greys the candidate list
       and blocks pointer events — bound on app-candidate-card-table-view
       below (not this wrapper) so it no longer also dims the "No
       Candidates Invited" empty state below it, which has nothing to grey
       out or block clicks on. -->
  <div infiniteScroll
    [infiniteScrollDistance]="5"
    [infiniteScrollThrottle]="200"
    [infiniteScrollContainer]="'.jc-v3-entity-details-body'"
    [fromRoot]="true"
    [alwaysCallback]="true"
    (scrolled)="onScrollDown()" id="entity-container">

    <!-- Initial-load skeleton — ports V2 at :42-44. V3 previously
         showed a blank area until the first response arrived. -->
    <div class="col-12" *ngIf="loadAPIcall && response?.length === 0">
      <app-common-skeleton [countforView]="4" [NameOftheScreen]="'jobcardlarge'"></app-common-skeleton>
    </div>

    <app-candidate-card-table-view
      [ngClass]="{'disabled': !appliedJob?.availability || appliedJob?.status !== 'ACTIVE'}"
      [designVersion]="'v3'"
      [pageName]="'candidates-invited'"
      [response]="response"
      [loadAPIcall]="loadAPIcall"
      [jobDetails]="appliedJob"
      [userId]="userId"
      [showTimeline]="false"
      [stopscrollFlag]="stopscrollFlag"
      (onViewProfile)="open($event)"
      (onDownloadResume)="downloadResume($event)"
      (onOpenDocuments)="openDocuments($event)"
      (onStatusUpdate)="updateStatus($event.status, $event.candidate)">
    </app-candidate-card-table-view>

    <!-- Pagination skeleton — shown when loading additional pages on top
         of an existing list. Ports V2 at :53. -->
    <div class="col-12" *ngIf="loadAPIcall && response?.length > 0">
      <app-common-skeleton [countforView]="2" [NameOftheScreen]="'jobcardlarge'"></app-common-skeleton>
    </div>
    <div *ngIf="!loadAPIcall && response?.length === 0" class="jc-v3-empty-state">
      <svg width="200" height="180" viewBox="0 0 200 180" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="100" cy="90" r="80" fill="#F5F3FF"/>
        <circle cx="100" cy="68" r="22" fill="#EDE9FE" stroke="#7C3AED" stroke-width="1.8"/>
        <path d="M82 68 a18 18 0 0 1 36 0" fill="#DDD6FE"/>
        <circle cx="100" cy="66" r="9" fill="#ffffff" stroke="#7C3AED" stroke-width="1.5"/>
        <path d="M74 108 c0-14.4 11.6-26 26-26h0c14.4 0 26 11.6 26 26" fill="#EDE9FE" stroke="#7C3AED" stroke-width="1.8" stroke-linecap="round"/>
        <rect x="120" y="88" width="36" height="26" rx="5" fill="#ffffff" stroke="#7C3AED" stroke-width="1.5"/>
        <path d="M120 96 l18 10 l18-10" stroke="#7C3AED" stroke-width="1.5" fill="none" stroke-linecap="round"/>
        <circle cx="50" cy="52" r="3" fill="#A78BFA"/>
        <circle cx="155" cy="58" r="2" fill="#C4B5FD"/>
        <circle cx="148" cy="130" r="3.5" fill="#A78BFA" opacity="0.5"/>
      </svg>
      <h3>No Candidates Invited</h3>
      <p>Candidates you invite to apply for this job will appear here.</p>
    </div>
  </div>
</ng-container>

<!-- Document Management — opens when V3 row's Documents icon fires
     `(onOpenDocuments)`. Same component / wiring as job-applicants. -->
<app-candidate-documents
  *ngIf="selectedCandidateForDocument"
  [pageName]="'candidate-card'"
  [isOpen]="showDocumentSection"
  [listOfDocuments]="typeOfDocuments"
  [candidateId]="selectedCandidateForDocument.candidateId"
  [jobId]="jobDetails.jobId"
  [count]="totalMandatoryDocuments"
  [allDocumentsVerified]="allVerified"
  (close)="closeDocuments()"
  (save)="saveDocuments($event)"
  (dataChanged)="refreshDocumentData()">
</app-candidate-documents>
